import { render, staticRenderFns } from "./about.vue?vue&type=template&id=3ea316a4&scoped=true&"
var script = {}
import style0 from "./about.vue?vue&type=style&index=0&id=3ea316a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea316a4",
  null
  
)

export default component.exports